import "#legacy/shared/client/jst.js";
import "#/shared/api/api-host-global.js";
import "#legacy/shared/events.js";
import "#legacy/utilities/params.js";

window.AppointmentBooking ??= {};
window.AppointmentBooking.RelatedProvidersWidget ??= {};
window.AppointmentBooking.RelatedProvidersWidget.Views ??= {};

AppointmentBooking.RelatedProvidersWidget.Views.Widget = class Widget extends Backbone.View {
  constructor() {
    super(...arguments);
    this.initialize = this.initialize.bind(this);
    this.render = this.render.bind(this);
    this.I18n = this.I18n.bind(this);
    this.fetchData = this.fetchData.bind(this);
    this.apiParams = this.apiParams.bind(this);
    this.searchParamsObject = this.searchParamsObject.bind(this);
    this.appendSearchUrl = this.appendSearchUrl.bind(this);
  }

  initialize(options = {}) {
    this.providers = new Backbone.Collection();
    this.model.set("providers", this.providers);

    return this.fetchData().then((physiciansData) => {
      const searchUrl = this.model.get("searchUrl");
      if (searchUrl) {
        this.appendSearchUrl(physiciansData.results, searchUrl);
      }
      this.providers.reset(physiciansData.results);
      return this.trigger("ready");
    });
  }

  // RENDERING

  render() {
    this.$el.html(
      window.Sparkle.Client.jstTemplate(this.template)({
        providers: this.model.get("providers").toJSON(),
        backToSearchUrl: this.model.get("searchUrl"),
        I18n: this.I18n(),
      }),
    );

    Sparkle.Events.contentUpdated(this.el);

    return this;
  }

  // PRIVATE

  I18n() {
    return AppointmentBooking.config.i18n.related_providers_widget;
  }

  fetchData() {
    return jQuery.getJSON(
      this.relatedProvidersUrl.replace("%{physicianId}", this.model.get("currentProviderId")),
      this.apiParams(),
    );
  }

  apiParams() {
    return Sparkle.Utilities.mergeParams(
      {
        limit_before: this.model.get("limitBefore"),
        limit_after: this.model.get("limitAfter"),
        passive_boosts: this.model.get("passiveBoosts"),
        sort: this.model.get("sort"),
        open_scheduling: this.model.get("openScheduling"),
      },
      this.searchParamsObject(),
    );
  }

  searchParamsObject() {
    const paramsObject = {};
    const { searchParams } = new URL(this.model.get("searchUrl"));
    searchParams.forEach((value, key) => (paramsObject[key] = value));

    return paramsObject;
  }

  appendSearchUrl(providers, searchUrl) {
    return providers.forEach((provider) => {
      const providerUrl = new URL(provider.url);
      providerUrl.searchParams.append("search_url", searchUrl);
      return (provider.url = providerUrl.toJSON());
    });
  }
};
AppointmentBooking.RelatedProvidersWidget.Views.Widget.prototype.tagName = "section";
AppointmentBooking.RelatedProvidersWidget.Views.Widget.prototype.className = "related-providers-widget";
AppointmentBooking.RelatedProvidersWidget.Views.Widget.prototype.template =
  "appointment_booking/related_providers_widget/templates/widget";

AppointmentBooking.RelatedProvidersWidget.Views.Widget.prototype.relatedProvidersUrl = window.Sparkle.apiHost
  ? window.Sparkle.apiHost +
    window.SparkleConfig.routes.embed.relatedProviders.replace("PHYSICIAN_ID", "%{physicianId}")
  : undefined;
